import React from 'react'
import Sun from '@iconscout/react-unicons/icons/uil-sun'
import Moon from '@iconscout/react-unicons/icons/uil-moon'
import './Toggle.css'
const Toggle = () => {
  return (
    <div className="toggle">
        <Sun/>
        <Moon/>
        <div className="t-button">

        </div>
    </div>
  )
}

export default Toggle